import React, {Component} from 'react'
import PropTypes from "prop-types"

class ColNumberBatches extends Component {
    render() {
        const {item} = this.props
        const {batch_count} = item

        return <td className="colThongke">
            <span>
                <strong>{batch_count === 0 ? '-' : batch_count}</strong>
            </span>
        </td>
    }
}

ColNumberBatches.propTypes = {
    item: PropTypes.object.isRequired
}

export default ColNumberBatches